import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	id: null,
	name: "Usuário",
	email: "example@email.com",
	user_created: false,
};

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		onUserAuthenticated: (state, action) => {
			Object.keys(state).forEach((key) => {
				state[key] = action.payload[key] ?? state[key];
			});
			state.user_created = false;
		},
		onUserRegister: (state) => {
			state.user_created = true;
		},
		onUserLogOut: (state) => {
			Object.keys(initialState).forEach((key) => {
				state[key] = initialState[key];
			});
		},
	},
});

export const { onUserRegister, onUserAuthenticated, onUserLogOut } = userSlice.actions;

export default userSlice.reducer;
